import React, { useEffect } from "react";
import { CustomTable } from "../../../Component/UI/Table";
import SwitchButton from "../../../Component/UI/SwitchButton/Switch";
import { NavLink } from "react-router-dom";
import { TbEdit } from "react-icons/tb";
import { TbSend } from "react-icons/tb";
import { IoCloseOutline } from "react-icons/io5";
import axios from "../../../config/axiosConfig";

import { fetchCompletedEvents } from "../../../Redux/Slices/Events/Events";
import { useDispatch, useSelector } from "react-redux";
import { to12Hour, YtoD } from "../../../config/formattedDate";
import {
  setFilter,
  setFrom_date,
  setSearch_key,
  setTo_date,
  setClear,
} from "../../../Redux/Slices/AdminFilters/Search";

export const Completed = () => {
  const dispatch = useDispatch();
  const { search_key, from_date, to_date, filter } = useSelector(
    (i) => i.SearchFilters
  );

  const { data, loading, hasErrors } = useSelector((state) => state.Events);

  useEffect(() => {
    dispatch(fetchCompletedEvents(search_key, from_date, to_date));
  }, [dispatch, filter]);

  useEffect(() => {
    return () => {
      //dispatch(setSearch_key(""));
      dispatch(setTo_date(""));
      dispatch(setFrom_date(""));
      dispatch(setFilter());
      dispatch(setClear());
    };
  }, []);

  const tBodyData = data?.completed?.map(
    ({
      name,
      speaker_name,
      event_date,
      start_time,
      end_time,
      type,
      status,
      id,
      coordinator,
      description,
    }) => {
      let Mode = type ? (
        <div style={{ color: "green" }}>Online</div>
      ) : (
        "Offline"
      );
      const date = YtoD(event_date.split(" ")[0]);
      const time = `${to12Hour(start_time)} - ${to12Hour(end_time)}`;

      return {
        date,
        name: (
          <NavLink
            to="/Eventdetails"
            state={{
              name,
              speaker_name,
              event_date,
              start_time,
              end_time,
              type,
              status,
              id,
              coordinator,
              description,
            }}
            style={{ textDecoration: "none", color: "black" }}
          >
            {name}
          </NavLink>
        ),
        speaker_name,
        time,
        Mode,
        status: <div style={{ color: "green" }}>Completed</div>,
      };
    }
  );

  const tHead = [
    "Date",
    "Event Name",
    "Speaker Name",
    "Time",
    "Mode",
    "Status",
  ];

  return <CustomTable tHead={tHead} tBody={tBodyData} />;
};
